/*
 * Copyright © 2023 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ZeitraumFeld} from '@dv/kitadmin/models';

/**
 * Extension of the ZeitraumFeld to hold additional, TempExtraPlatz specific information.
 */
export class TempExtraZeitraumFeld extends ZeitraumFeld {

    /**
     * When the field is part of an existing extra platz in the backend, the ID of that extra Platz.
     */
    public existingPlatzId: string | null = null;

    /**
     * Used to mark fields of existing extraPlaetze for removal.
     */
    public removed: boolean = false;
}
